import { HOW_IT_WORKS } from '@/content/site-content';
import { STEP_IMAGES } from '@/content/images';

/**
 * Six photo cards, each darkened enough for white copy to sit on it, with the
 * step number in an orange disc and a dashed arrow joining them across a row.
 */
export function HowItWorksSection() {
  return (
    <section id="how-it-works" className="container-page scroll-mt-28 py-16 lg:py-20">
      <h2 className="text-center text-3xl font-extrabold sm:text-4xl">
        How <span className="text-brand-600">TeenTack</span> Works
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
          className="ml-1 inline-block size-6 align-top text-brand-600"
        >
          <path
            d="M3 15 1 18M7 11 5.5 6.5M12 12l4-3"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </h2>

      <ol className="mt-12 grid gap-x-8 gap-y-8 md:grid-cols-2 lg:grid-cols-3">
        {HOW_IT_WORKS.map((step, index) => {
          const image = STEP_IMAGES[index];
          // The dashed connector only makes sense between cards on the same row.
          const showArrow = index % 3 !== 2;

          return (
            <li key={step.number} className="relative">
              <article className="relative h-full overflow-hidden rounded-[1.5rem] bg-accent-900">
                {image && (
                  <img
                    src={image.src}
                    alt=""
                    width={image.width}
                    height={image.height}
                    loading="lazy"
                    decoding="async"
                    aria-hidden="true"
                    className="absolute inset-0 size-full object-cover opacity-75"
                  />
                )}
                <div
                  aria-hidden="true"
                  className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/15"
                />

                <div className="relative flex min-h-72 flex-col justify-end p-5">
                  <span className="absolute top-4 left-4 grid size-9 place-items-center rounded-full bg-brand-600 text-sm font-extrabold text-white">
                    {step.number}
                  </span>
                  <h3 className="text-lg font-bold text-white">{step.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-white/85">{step.description}</p>
                </div>
              </article>

              {showArrow && (
                <svg
                  aria-hidden="true"
                  viewBox="0 0 40 12"
                  className="absolute top-1/2 -right-7 hidden h-3 w-6 -translate-y-1/2 text-brand-400 lg:block"
                >
                  <path
                    d="M0 6h30"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeDasharray="4 4"
                  />
                  <path
                    d="m28 2 6 4-6 4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </li>
          );
        })}
      </ol>
    </section>
  );
}
